import { getTempApprovalManageList, disableStatus, enableStatus, copyRow } from '@/api/tempApprovalManage';
export default {
  namespaced: true,
  state: {
    totalCount: 0,
    dataSource: [],
    filter: {}
  },
  mutations: {
    SAVE_STATE (state, payload = {}) {
      // 由于不想全部把state给改了，所以我想把每一个数据都单独塞一下
      const keyList = Object.keys(payload);
      keyList.forEach(key => {
        state[key] = payload[key];
      });
    }
  },
  actions: {
    getTableInfo ({ commit, dispatch, state }, { filter }) {
      const pasFilter = { ...filter };
      getTempApprovalManageList(pasFilter).then(res => {
        const { code, data } = res.data;
        if (code == 200) {
          commit('SAVE_STATE', { dataSource: data.records, totalCount: data.total, filter });
        }
      });
    },
    // 启用，停用
    submitStatus ({ commit, dispatch }, { id, status }) {
      return new Promise(resolve => {
        //  status 1 是当前是启用状态，2 是当前状态是禁用状态
        const method = status == 1 ? disableStatus : enableStatus;
        method(id).then(res => {
          const { code } = res.data;
          if (code == 200) {
            resolve(true);
          }
        });
      });
    },
    // 复制
    submitCopy ({ commit, dispatch }, { id }) {
      return new Promise(resolve => {
        copyRow(id).then(res => {
          const { code } = res.data;
          if (code == 200) {
            resolve(true);
          }
        });
      });
    }
  }
};
